import React from 'react';
import { FiExternalLink } from 'react-icons/fi';

const TopBar = ({ currentProject }) => {
  const handleBackToDashboard = () => {
    window.location.href = process.env.REACT_APP_MAIN_DASHBOARD_URL || 'https://app.gyso.au';
  };

  return (
    <div className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <img
              className="h-8 w-auto"
              src="https://www.dropbox.com/scl/fi/x19wn3gvnkldomxojhcx8/GYSO-Logo.png?rlkey=z0gau2aihct344okihofnoke5&st=5uelkmzi&raw=1"
              alt="GYSO"
            />
            <span className="text-xl font-semibold text-gray-900">
              GYSO Data Collection
            </span>
          </div>
          
          <div className="flex items-center space-x-4">
            {currentProject && (
              <span className="text-sm text-gray-600">
                Project: <span className="font-medium text-gray-900">{currentProject.project_name}</span>
              </span>
            )}
            <button
              onClick={handleBackToDashboard}
              className="inline-flex items-center space-x-1 text-sm text-blue-600 hover:text-blue-700 transition-colors duration-200"
            >
              <span>Back to Dashboard</span>
              <FiExternalLink className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;